import { sceneryTile as tile, type WorldBackdrop } from './worldShapeKit';

/** Terrain-led scenes: mesas sit behind sand, ice breaks into facets, and
 * wetlands keep long horizontal water gaps between leaning vegetation. */
export const LANDSCAPE_BACKDROPS = {
  desert: {
    far: tile('dunes', [['mesa', 180, 313, 480, 233], ['mesa', 1290, 329, 460, 226]]),
    mid: tile('dunes', [['obelisk', 910, 319, 78, 131]]),
    near: tile('dunes', [['basalt', 1610, 337, 230, 78]]),
  },
  savanna: {
    far: tile('hills', [['mesa', 630, 317, 580, 168]]),
    mid: tile('banks', [['acacia', 160, 309, 440, 260], ['acacia', 1380, 330, 480, 310]]),
    near: tile('banks', [['reeds', 540, 329, 190, 137], ['reeds', 1650, 335, 230, 125]]),
  },
  mountains: {
    far: tile('crags', [['mountain', 130, 350, 750, 340], ['mountain', 1180, 355, 800, 305]]),
    mid: tile('crags', [['mountain', 400, 335, 470, 270], ['crystal', 1450, 325, 300, 241]]),
    near: tile('crags', [['crystal', 740, 342, 220, 198], ['basalt', 1780, 347, 245, 124]]),
  },
  arctic: {
    far: tile('hills', [['mountain', 250, 339, 760, 293], ['mountain', 1490, 334, 530, 210]]),
    mid: tile('banks', [['crystal', 170, 315, 380, 230], ['crystal', 1440, 326, 310, 211]]),
    near: tile('shelf', [['crystal', 870, 322, 190, 143], ['crystal', 1950, 321, 130, 88]]),
  },
  moor: {
    far: tile('hills', [['mountain', 260, 328, 880, 222]]),
    mid: tile('hills', [['snag', 1080, 314, 200, 204], ['obelisk', 1810, 330, 82, 117]]),
    near: tile('banks', [['reeds', 330, 325, 130, 99], ['reeds', 1330, 323, 160, 123], ['reeds', 2050, 329, 110, 77]]),
  },
  marsh: {
    far: tile('banks', [['willow', 240, 315, 360, 236], ['willow', 1480, 338, 430, 277]]),
    mid: tile('banks', [['willow', 720, 333, 470, 320], ['snag', 1920, 335, 180, 250]]),
    near: tile('banks', [['reeds', 330, 325, 170, 133], ['reeds', 1290, 321, 190, 159], ['reeds', 2010, 334, 120, 117]]),
  },
  coast: {
    far: tile('banks', [['mesa', 120, 329, 630, 220], ['mesa', 1410, 337, 530, 171]]),
    mid: tile('hills', [['palm', 580, 330, 275, 276], ['palm', 1780, 336, 320, 301]]),
    near: tile('dunes', [['reeds', 880, 333, 130, 73]]),
  },
  drowned: {
    far: tile('banks', [['snag', 230, 322, 220, 205], ['ruin', 1370, 327, 315, 227]]),
    mid: tile('banks', [['ruin', 400, 323, 410, 248], ['willow', 1670, 339, 320, 246]]),
    near: tile('banks', [['reeds', 250, 327, 160, 108], ['reeds', 1200, 329, 190, 145], ['basalt', 2020, 338, 195, 89]]),
  },
  tempest: {
    far: tile('crags', [['mountain', 180, 344, 690, 284], ['mesa', 1400, 335, 560, 277]]),
    mid: tile('crags', [['basalt', 380, 329, 410, 278], ['basalt', 1520, 335, 300, 213]]),
    near: tile('crags', [['snag', 870, 340, 160, 187], ['basalt', 1970, 340, 230, 104]]),
  },
} satisfies Record<string, WorldBackdrop>;
